import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCheck, Settings, ArrowLeft } from 'lucide-react';
import { useNotificationFeed } from '../../hooks/useNotificationFeed';
import NotificationFeedList from './NotificationFeedList';
import NotificationSettings from './NotificationSettings';

const NotificationPanel: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [view, setView] = useState<'inbox' | 'settings'>('inbox');
  const feed = useNotificationFeed(onClose);

  return (
    <motion.div
      initial={{ opacity: 0, y: -8, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -8, scale: 0.97 }}
      transition={{ duration: 0.16, ease: 'easeOut' }}
      className="absolute right-0 mt-2 w-[380px] max-w-[92vw] rounded-2xl shadow-2xl overflow-hidden z-50 flex flex-col border"
      style={{ backgroundColor: 'var(--component-bg-color)', color: 'var(--text-color)', maxHeight: '80vh', borderColor: 'var(--border-item-dark, transparent)' }}
    >
      <div className="flex items-center justify-between px-4 py-3 border-b" style={{ borderColor: 'var(--bg-item)' }}>
        {view === 'settings' ? (
          <button className="flex items-center gap-1 text-sm font-semibold" onClick={() => setView('inbox')}>
            <ArrowLeft size={16} /> การแจ้งเตือน
          </button>
        ) : (
          <span className="font-bold">การแจ้งเตือน</span>
        )}
        <div className="flex items-center gap-2">
          {view === 'inbox' && (
            <>
              <span
                title={feed.sseStatus === 'connected' ? 'เชื่อมต่อ realtime แล้ว' : 'กำลังเชื่อมต่อ realtime'}
                className="w-2 h-2 rounded-full transition-colors duration-300"
                style={{ backgroundColor: feed.sseStatus === 'connected' ? '#22c55e' : '#9ca3af' }}
              />
              <button
                onClick={feed.markAllRead}
                className="flex items-center gap-1 text-xs font-semibold px-2 py-1.5 rounded-lg hover:opacity-70 transition-opacity active:scale-90"
              >
                <CheckCheck size={14} /> อ่านทั้งหมด
              </button>
              <button title="ตั้งค่า" onClick={() => setView('settings')} className="p-1.5 rounded-lg hover:opacity-70 transition-opacity active:scale-90">
                <Settings size={16} />
              </button>
            </>
          )}
        </div>
      </div>

      {view === 'inbox' ? <NotificationFeedList feed={feed} variant="dropdown" /> : <NotificationSettings />}
    </motion.div>
  );
};

export default NotificationPanel;
